module.exports = __webpack_public_path__ + "img/typhoon.7975c87e.png";